module.exports = __webpack_public_path__ + "img/banner_pj.fbb84c8b.png";